import kamala from '../../kamala'
import Crop from './Crop'

Crop.install = function (Vue) {
  kamala(Vue)
  Vue.component(Crop.name, Crop)
}

export default Crop
